import Vue from "vue";
import { mapGetters } from "vuex";
import { EventBus } from "@/services/EventBus";
import Modal from "@/components/modal/Modal.vue";
import Dropdown from "@/components/dropdown/Dropdown.vue";
import InputText from "@/components/inputText/InputText.vue";
import Loader from "@/components/loader/Loader.vue";
import TimeInterval from "@/modules/timeInterval/TimeInterval.vue";
import { translateService } from "@/services/translateService";
import { viewApiService } from "@/api/view/view.api";
import { LOCAL_VIEW_ID_PREFIX } from "@/consts/consts";
import { getViewName } from "@/utils";

export default {
  name: "view-tabs",
  data() {
    return {
      form: {
        name: {
          name: "name",
          validator: { required: true, uniqueTabName: true },
          placeholder: "viewCreateModal.inputLabel"
        }
      },
      saving: null,
      removing: null,
      max: null,
      more: false,
      updating: true,
      full: false,
      limit: false,
      isShowDownload: false,
      camera_list: "",
      isCopy: false
    };
  },
  async created() {
    if (Object.keys(translateService.translate) === 0) {
      translateService.translate = await translateService.getTranslates();
    }

    this.$validator.extend("uniqueTabName", {
      getMessage: field => "customValidationError.uniqueViewName",
      validate: value => {
        return (
          (!this.localViews.some(item => {
            return value == item.name;
          }) ||
            // здесь имена вьюс могут совпадать
            (!this.isCopy && value == this.saving.name)) &&
          value !== translateService.translate.ru["tabs"]["mainView"] &&
          value !== "Main View"
        );
      }
    });
  },
  mounted() {
    EventBus.$on("resize:start", () => {
      this.updating = true;
    });
    EventBus.$on("resize:end", this.updateTabs);
    EventBus.$on("open:export", this.toggleExport);
  },
  computed: {
    ...mapGetters({
      activeView: "getActiveView",
      grids: "getGrids",
      activeGrid: "getActiveGrid",
      archCnvEnabled: "getArchCnvEnabled",
      views: "getViews",
      localViews: "getLocalViews"
    }),
    list() {
      let result = this.views.map(item => {
        this.$set(item, "menu", false);
        return item;
      });
      return {
        tabs: result.slice(0, this.max),
        dropdown: result.slice(this.max)
      };
    },
    downloadCamsView() {
      return this.activeView.cams.filter(cam => cam.privilege !== 1);
    },
    dropdownMenu() {
      return (tab, isHorizintal = true) => {
        return [
          {
            title: "viewAction.undo",
            action: () => this.reset(tab),
            isHorizintal: true,
            displayCondition: tab.isGlobalView
              ? false
              : tab.changed && this.activeView && this.activeView.id == tab.id
          },
          {
            title: "viewAction.clear",
            action: () => this.removeCamsFromView(),
            displayCondition: tab.isGlobalView
              ? false
              : tab.temp &&
                tab.cams.length &&
                this.activeView &&
                this.activeView.id == tab.id
          },
          {
            title: "btn.save",
            action: () => this.save(tab),
            isHorizintal: true,
            displayCondition: tab.isGlobalView
              ? false
              : !tab.temp &&
                tab.changed &&
                this.activeView &&
                this.activeView.id == tab.id
          },
          {
            title: "viewAction.saveAs",
            action: () => this.edit(tab, !tab.temp),
            displayCondition: tab.isGlobalView
              ? false
              : tab.temp
              ? tab.changed && this.activeView && this.activeView.id == tab.id
              : true
          },
          {
            title: "viewAction.delete",
            action: () => (this.removing = tab),
            displayCondition: tab.isGlobalView ? false : !tab.temp
          },
          {
            title: "viewAction.rename",
            action: () => this.edit(tab),
            displayCondition: tab.isGlobalView ? false : !tab.temp
          },
          {
            title: "viewAction.downloadAll",
            action: () =>
              this.toggleExport(
                this.downloadCamsView.map(cam => cam.id).join(";")
              ),
            displayCondition:
              this.archCnvEnabled &&
              this.activeView &&
              this.activeView.id == tab.id &&
              this.downloadCamsView.length !== 0
          }
        ].filter(
          option =>
            option.displayCondition &&
            (isHorizintal === false ? option.isHorizintal !== true : true)
        );
      };
    }
  },
  watch: {
    views: {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          this.updateTabs();
        });
      }
    },
    "$store.state.stream": {
      handler() {
        this.updateTabs();
      }
    }
  },
  methods: {
    setMaxTabs() {
      if (this.$refs.list) {
        let items = this.$refs.list.children;

        let itemsWidth = [...items].reduce((prev, curr) => {
          let selector = curr.getElementsByClassName("inner");
          let el = selector.length ? selector[0] : curr;

          return prev + el.clientWidth;
        }, 0);

        this.full = itemsWidth / this.$refs.list.clientWidth > 0.5;

        if (
          items.length &&
          this.$refs.list.clientHeight > items[0].clientHeight
        ) {
          this.max = this.max - 1;
          this.more = true;

          this.$nextTick(() => {
            this.setMaxTabs();
          });
        } else {
          this.updating = false;
        }
      }
    },
    updateTabs() {
      this.updating = true;
      this.more = false;
      this.max = this.views.length;

      setTimeout(() => {
        this.setMaxTabs();
      }, 300);
    },
    select(view) {
      this.$store.commit("setGrid", view.grid);
      this.$router.push({ name: "views", params: { viewId: view.id } });
    },
    edit(tab, isCopy = false) {
      if (tab.isGlobalView) {
        return;
      }

      this.isCopy = isCopy;

      if (this.views.length > 10 && (tab.temp || this.isCopy)) {
        this.limit = true;
      } else {
        this.form.name.value = tab.temp ? this.getNewName() : tab.name;
        this.saving = tab;
        if (this.isCopy) {
          this.saving = { ...this.saving, id: undefined };
        }

        Vue.nextTick(() => {
          let input = this.$refs["form-name"];

          if (input) input.$emit("focus");
        });

        tab.menu = false;
      }
    },
    save(tab) {
      if (tab.isGlobalView) {
        return;
      }

      let name = this.form.name.value;
      this.$validator.validateAll().then(result => {
        if (result) {
          viewApiService
            .saveView(
              {
                ...tab,
                cams: tab.cams.slice(
                  0,
                  this.grids.find(g => g.value == tab.grid).max
                ),
                name: name ? name : tab.name
              },
              this.$store.state.user.login
            )
            .then(view => {
              this.$store.commit("resetTempView");
              this.$store.commit("saveView", view);

              this.isCopy = false;
              this.form.name.value = null;
              this.saving = null;
              this.$router.push(
                { name: "views", params: { viewId: view.id } },
                () => {
                  this.$store.commit("setGrid", view.grid);
                }
              );
            });
        }
      });
    },
    reset(tab) {
      if (tab.isGlobalView) {
        return;
      }

      if (tab.temp) {
        this.$store.commit("resetTempView");
        this.$store.commit("setGrid", 1);
      } else {
        const views = viewApiService.getLocalViews(
          this.$store.state.user.login
        );

        const view = views.find(v => v.id == tab.id);
        this.$store.commit("setGrid", view.grid);
        this.$store.commit("saveView", view);
        this.$nextTick(() => {
          EventBus.$emit("views:select");
        });
      }
    },
    removeCamsFromView() {
      this.$store.commit("removeCamFromView", {
        camId: null,
        viewId: this.$store.getters.getActiveView.id
      });
    },
    remove(tab) {
      if (tab.isGlobalView) {
        return;
      }

      this.removing = null;

      viewApiService
        .removeView(tab.id, this.$store.state.user.login)
        .then(viewId => {
          this.$store.commit("removeView", viewId);

          if (this.views.length === 1 && !this.views[0].cams.length) {
            this.$store.commit("resetTempView");
            this.$store.commit("setGrid", 1);
          }

          if (viewId == this.$route.params.viewId) {
            this.$router.push({
              name: "views",
              params: { viewId: this.views[0].id }
            });
          }
        });
    },
    toggleExport(camera_list = "") {
      this.camera_list = camera_list;
      this.isShowDownload = !this.isShowDownload;
    },
    onSaveVideo(data) {
      EventBus.$emit("export-files", {
        ...data,
        camera_list: this.camera_list
      });
      this.toggleExport();
    },
    getNewName() {
      let result = 1;

      this.localViews.forEach(item => {
        const itemIdNumber = Number(item.id.split(LOCAL_VIEW_ID_PREFIX)[1]);

        if (result <= itemIdNumber) result = itemIdNumber + 1;
      });

      return this.$t("tabs.view") + " " + result;
    },
    getViewName
  },
  components: {
    Modal,
    Dropdown,
    InputText,
    Loader,
    TimeInterval
  }
};



// WEBPACK FOOTER //
// ./src/modules/viewTabs/viewTabs.js